import React from 'react'
import classnames from 'classnames'

type TickSize = 'small' | 'large'

type TickProps = {
  x: number
  size: TickSize
  label: string
}

const Tick: React.FC<TickProps> = ({ x, size, label }) => {
  const getLabelContent = () => {
    if (label && label.length > 0) {
      return <div className="label">{label}</div>
    }
    return null
  }

  const tickStyle: React.CSSProperties = {
    left: 0,
    transform: `translate(${x}px, 0px)`,
  }

  return (
    <div className={classnames('tick', `tick--${size}`)} style={tickStyle}>
      <div className="tick__content">
        {getLabelContent()}
        <div className="graphic"></div>
      </div>
    </div>
  )
}

// Use memo to prevent unnecessary re-renders
export default React.memo(Tick)
